import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { DataService } from '../data.service';

declare var Nanobar: any;
declare var $: any;
declare var toastr: any;

@Component({
  selector: 'app-add-registered-vendor',
  templateUrl: './add-registered-vendor.component.html',
  styleUrls: ['./add-registered-vendor.component.css']
})
export class AddRegisteredVendorComponent implements OnInit {

  constructor(
    private dataService: DataService,
    private formBuilder: FormBuilder
  ) {
    this.dataService.pageName = 'Add Registered Vendors';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
  }
  registeredVendorForm: FormGroup = this.formBuilder.group({
    vendor: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    admin_name: ['', Validators.required]
  });

  ngOnInit() {
  }

  onSubmitRegisterForm() {
    this.registeredVendorForm.value.auth_token = window.localStorage.getItem('token');
    console.log(this.registeredVendorForm.value);
    this.dataService.addRegisteredVendor(this.registeredVendorForm.value).subscribe(
      data => {
        console.log(data);
      },
      err => {
        console.log(err);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/add-registered-vendor/add-registered-vendor.component.ts